import ExpertConsultationsDetail, {
  getStaticProps,
  getStaticPaths,
} from '@public/ExpertDetail/Consultations'

export { getStaticProps, getStaticPaths }

export default ExpertConsultationsDetail
